import React from 'react';
import styles from './GearPageSkeleton.module.css';
import GearCardSkeleton from './GearCardSkeleton';

function GearPageSkeleton() {
  return (
    <div>
      {Array.from({ length: 3 }).map((_, sectionIndex) => (
        <div key={sectionIndex} className={styles.gearCategorySection}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionHeaderTopRow}>
              <div className={styles.titleSkeleton}>
                <div className={styles.shimmer}></div>
              </div>
              <div className={styles.filterButtonSkeleton}>
                <div className={styles.shimmer}></div>
              </div>
            </div>
          </div>
          <div className={styles.gearCardsRow}>
            {Array.from({ length: 5 }).map((_, cardIndex) => (
              <GearCardSkeleton key={cardIndex} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default GearPageSkeleton;
